import { shopcarcount, checktokenstatus } from '@/api/index';

const LOCAL_CART_KEY = 'localCart'; 
const state = {
  cartNum: 0
}

const mutations = {
  SET_CARTNUM: (state, cartNum) => {
    console.log('cartNum变化了', cartNum);
    state.cartNum = cartNum;
  }
}

const actions = {
  setCartNum({ commit }, data) {
    commit('SET_CARTNUM', data)
  },

  async refreshCartCount({ commit }) {
    console.log('refreshCartCount dipanggil');
    let loggedIn = false;
    try {
      const res = await checktokenstatus({token: localStorage.getItem('hpToken')});
      loggedIn = res.code == 0 && res.result.token_status === true;
    } catch (e) {
      loggedIn = false;
    }

    if (!loggedIn) {
      let cart = [];
      try {
        const raw = localStorage.getItem(LOCAL_CART_KEY);
        cart = raw ? JSON.parse(raw) : [];
      } catch (e) {
        cart = [];
      }
      commit('SET_CARTNUM', cart.length);
      return;
    }

    try {
      const res = await shopcarcount();
      if (res.code == 0) {
        commit('SET_CARTNUM', res.result.count);
      }
    } catch (error) {
      console.error('获取购物车数量失败:', error);
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}